const ENGLISH_NAMES = ['live', 'voucher', 'video'];

export const checkIsEnglishName = (name) =>
	typeof name === 'string' ? ENGLISH_NAMES.includes(name.toLowerCase()) : false;
